// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__iJEDl","requiredAsterisk":"Info_requiredAsterisk__2vyOz"};